import { useState, useMemo, useCallback, type ReactNode } from 'react';
import { SelectedTimestampContext, type SelectedTimestampContextType } from './selectedTimestampTypes';

export const SelectedTimestampProvider = ({ children }: { children: ReactNode }) => {
  const [selectedTimestamp, setSelectedTimestampState] = useState<Date | null>(null);

  // Memoize the setter function to prevent it from changing on every render
  const setSelectedTimestamp = useCallback((timestamp: Date | null) => {
    setSelectedTimestampState(timestamp);
  }, []);

  const value: SelectedTimestampContextType = useMemo(
    () => ({
      selectedTimestamp,
      setSelectedTimestamp,
    }),
    [selectedTimestamp, setSelectedTimestamp]
  );

  return <SelectedTimestampContext.Provider value={value}>{children}</SelectedTimestampContext.Provider>;
};

